var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('el-form',{ref:"ruleForm",attrs:{"label-position":"top"}},[_c('ShippingIntegrationAddFormHeader',{ref:"header"}),_c('ShippingAddFormFooter',{attrs:{"updated":_vm.updated,"redirect":"shipping.integration"},on:{"submit":_vm.submitForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }